<script setup>

import Container from "./container.vue";
</script>

<template>
  <container>
    <el-form ref="formRef" label-width="128px">
      <el-form-item>
        <el-button type="primary" @click="auditPassBtClick">重新提交</el-button>
        <el-button class="lang-but" type="danger" @click="auditCloseBtClick">取消问题</el-button>
      </el-form-item>
    </el-form>
    <div>
    </div>
  </container>
</template>

<style scoped lang="scss">

</style>
<script>
import {requestSubmitAudit} from "../../api/feedback";

export default {
  name: "managerSubmit",
  inject: ['getValidateForm'],
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String,
    suggestionItems: {
      type: Array,
      default: () => []  // 默认值使用工厂函数返回空数组
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      //文件是否需要回显，如果传进来得数据有文件列表，则回显，不再显示上传文件框
      hasFileEchoShow:false,
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible:false,
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    }
  },
  methods: {
    async auditPassBtClick() {
      if (!await this.getValidateForm()) {
        return
      }
      // this.$refs['formRef'].validate((valid) => {
      //   if (!valid) {
      //     return
      //   }
        this.$confirm('确认重新提交?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let formData = {
            nowTaskId: this.taskId,
            questionId: this.questionId,
            taskDefKey: this.taskDefKey,
            variables: {
              approval: true,
            },
          }
          requestSubmitAudit(formData).then(res => {
            if (res.status == "0") {
              this.$DonMessage.success('提交成功!');
              this.backRouterPath();
            }
          })
        })
      // })
    },
    auditCloseBtClick() {
      this.$confirm('确认取消质量问题?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          variables: {
            approval: false,
          },
        }
        requestSubmitAudit(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('问题已取消!');
            this.backRouterPath();
          }
        })
      })
    }


  },
  mounted() {
  }
}
</script>
